import React from "react";
import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Col,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import tutorsModal from "models/tutors.modal";

import { Link } from "react-router-dom";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
import ParentandtutoractiveModal from "models/activeanddeactive.modal";
import EnquiryModal from "models/enquiries.modal";
import Loader from "components/loader/Loader";
import noimage from "../../assets/img/noimage.jpeg";


const TutorPage = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const[totalpage,setTotalpage] = useState()
  const initialPage = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(
    parseInt(initialPage, 10) || 1
  );
  const [perPage, setPerPage] = useState(10);
  const [status, setStatus] = useState("?status=All");
  console.log("data list", dataList)

  const getListData = async () => {
    setIsLoading(true);
    await tutorsModal
      .Tutorslist(status, parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          console.log("tutor list ------>", result?.meta);
          setDataList(result?.data || []);
          setTotalpage(result?.meta?.total_page)
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
        setDataList([]); // Set empty array on error to trigger dummy data
      });
  };
  useEffect(() => {
    getListData();
  }, [status]);
  const [newEquries, setnewEnquries] = useState();
  const [qualifiedEquries, setQualifiedEnquries] = useState();
  const [Pendingss, setPendingss] = useState();
  const [Disqualify, setDisqualify] = useState();
  const getalldataNumber = async () => {
    EnquiryModal.Addnewequriey()
      .then((responce) => {
        setnewEnquries(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.QualifiedEnquiry()

      .then((responce) => {
        setQualifiedEnquries(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.Pendingss()

      .then((responce) => {
        setPendingss(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.Disqualify()

      .then((responce) => {
        setDisqualify(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    getListData();
  }, [currentPage]);
  useEffect(() => {
    getListData();
    setCurrentPage(parseInt(searchParams.get("page"), 10) || 1);
    getalldataNumber();
  }, [location]);

  const [alldata, setAlldata] = useState();
  const [pendingdata, setPendingdata] = useState();
  const [approvedata, setApprovedata] = useState();
  const [rejectdata, setRejectdata] = useState();
  const [deactivedata, setDeactivedata] = useState();


  
  const getListDatacount = async () => {
    await tutorsModal
      .Tutorslistcount("?status=All")
      .then((result) => {
        setAlldata(result);
        console.log("123all",result)
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
    await tutorsModal
      .Tutorslistcount("?status=Pending")
      .then((result) => {
        setPendingdata(result);
        console.log("pendingg ",result)
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
    await tutorsModal
      .Tutorslistcount("?status=Approved")
      .then((result) => {
        setApprovedata(result);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
    await tutorsModal
      .Tutorslistcount("?status=Rejected")
      .then((result) => {
        setRejectdata(result);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
    await tutorsModal
      .Tutorslistcount("?status=Deactivated")
      .then((result) => {
        setDeactivedata(result);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getListDatacount();
  }, []);

  console.log("data count", alldata);
  const tableRef = useRef(null);
  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("tutors_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const handleDel = async (delId) => {
    const form = new FormData();
    form.append("is_active", "false");
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to deactive this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        ParentandtutoractiveModal.Active(delId, form)
          .then((res) => {
            Swal.fire("Deactive!", "The item has been deactive.", "success");
            // Refresh the list after deletion
            getListData();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
            Swal.fire(
              "Error!",
              "There was a problem dactive the item.",
              "error"
            );
          });
      }
    });
  };

  const handleAcc = async (delId) => {
    const form = new FormData();
    form.append("is_active", "true");
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to Active this user?",
      icon: "Success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Active it!",
    }).then((result) => {
      if (result.isConfirmed) {
        ParentandtutoractiveModal.Active(delId, form)
          .then((res) => {
            Swal.fire("Activated!", "The item has been Activated.", "success");
            // Refresh the list after deletion
            getListData();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
            Swal.fire("Error!", "There was a problem ctive the item.", "error");
          });
      }
    });
  };

  // Dummy data for testing when no API data is available
  const dummyData = [
    {
      user_id: 1,
      mobile: "9876543210",
      city: "Mumbai",
      date_joined: "2024-01-15T10:30:00Z",
      auth_user: {
        first_name: "John",
        last_name: "Doe",
        email: "john.doe@example.com",
        is_active: true,
        // profilePic: "https://via.placeholder.com/150/0000FF/808080?text=JD",
        profilePic:"https://media.istockphoto.com/id/1413766112/photo/successful-mature-businessman-looking-at-camera-with-confidence.webp?a=1&b=1&s=612x612&w=0&k=20&c=774fm_pppNJj-S1mSrArKVe08CLr4C1S2wZaImayyng="
      }
    },
    {
      user_id: 2,
      mobile: "9876543211",
      city: "Delhi",
      date_joined: "2024-02-20T14:15:00Z",
      auth_user: {
        first_name: "Jane",
        last_name: "Smith",
        email: "jane.smith@example.com",
        is_active: false,
        profilePic: "https://via.placeholder.com/150/FF0000/FFFFFF?text=JS",
        profilePic:"https://images.unsplash.com/photo-1480429370139-e0132c086e2a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fG1hbnxlbnwwfHwwfHx8MA%3D%3D"
      }
    },
    {
      user_id: 3,
      mobile: "9876543212",
      city: "Bangalore",
      date_joined: "2024-03-10T09:45:00Z",
      auth_user: {
        first_name: "Mike",
        last_name: "Johnson",
        email: "mike.johnson@example.com",
        is_active: true,
        // profilePic: "https://via.placeholder.com/150/00FF00/000000?text=MJ",
        profilePic:"https://plus.unsplash.com/premium_photo-1689977968861-9c91dbb16049?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bWFufGVufDB8fDB8fHww"
      }
    },
    {
      user_id: 4,
      mobile: "9876543213",
      city: "Chennai",
      date_joined: "2024-04-05T16:20:00Z",
      auth_user: {
        first_name: "Sarah",
        last_name: "Wilson",
        email: "sarah.wilson@example.com",
        is_active: true,
        // profilePic: "https://via.placeholder.com/150/FFFF00/000000?text=SW",
        profilePic:"https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFufGVufDB8fDB8fHww"
      }
    },
    {
      user_id: 5,
      mobile: "9876543214",
      city: "Pune",
      date_joined: "2024-05-12T11:30:00Z",
      auth_user: {
        first_name: "David",
        last_name: "Brown",
        email: "david.brown@example.com",
        is_active: false,
        // profilePic: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=DB",
        profilePic: "https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bWFufGVufDB8fDB8fHww",
      }
    }
  ];

  // Use dummy data if no API data is available, otherwise filter the actual data
  const filteredData = dataList && dataList.length > 0 
    ? dataList.filter((tutorItem) => {
        const searchString = searchTerm.toLowerCase();
        return (
          tutorItem?.auth_user?.first_name.toLowerCase().includes(searchString) ||
          tutorItem?.auth_user?.email.toLowerCase().includes(searchString) ||
          tutorItem?.mobile.toString().includes(searchString) ||
          tutorItem?.city.toLowerCase().includes(searchString)
        );
      })
    : dummyData.filter((tutorItem) => {
        const searchString = searchTerm.toLowerCase();
        return (
          tutorItem?.auth_user?.first_name.toLowerCase().includes(searchString) ||
          tutorItem?.auth_user?.email.toLowerCase().includes(searchString) ||
          tutorItem?.mobile.toString().includes(searchString) ||
          tutorItem?.city.toLowerCase().includes(searchString)
        );
      });


  return (
    
  <>
    <>
      <div className="pt-7 md:pt-2 overflow-hidden px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-center">
                <h3 className="mb-2 mb-md-0">All TUTOR</h3>

                <div className="d-flex flex-column flex-md-row justify-content-between ">
                  <Input
                    className="mr-md-4 mb-2 mb-md-0 ml-md-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Button
                    size="sm"
                    onClick={downloadPDF}
                    // style={{ width: "1x" }}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                    }}
                  >
                    <i class="fa-solid fa-download"></i>
                  </Button>
                </div>
                {/* 
                <div className="d-flex flex-row"></div> */}
              </CardHeader>
              <Row>
                <Col md={12}>
                  <div className="d-flex flex-row mb-2 pl-4">
                    <span
                      onClick={() => {
                        setStatus("?status=All");
                      }}
                      style={{
                        color: status === "?status=All" ? "blue" : "black",
                        display: "flex",
                        cursor: "pointer",
                        fontSize: "15px",
                      }}
                    >
                      All (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color: status == "?status=All" ? "black" : "blue",
                          marginTop: "1px",
                        }}
                      >
                        {alldata?.meta?.total}
                      </span>
                      )
                    </span>

                    <span
                      onClick={() => {
                        setStatus("?status=Pending");
                      }}
                      style={{
                        color: status === "?status=Pending" ? "blue" : "black",
                        display: "flex",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Pending (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color: status == "?status=Pending" ? "black" : "blue",
                          marginTop: "1px",
                        }}
                      >
                        {pendingdata?.meta?.total}
                      </span>
                      )
                    </span>

                    <span
                      onClick={() => {
                        setStatus("?status=Approved");
                      }}
                      style={{
                        color: status === "?status=Approved" ? "blue" : "black",
                        display: "flex",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Approved (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "?status=Approved" ? "black" : "blue",
                          marginTop: "1px",
                        }}
                      >
                        {approvedata?.meta?.total}
                      </span>
                      )
                    </span>

                    <span
                      style={{
                        display: "flex",
                        color: status === "?status=Rejected" ? "blue" : "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      onClick={() => {
                        setStatus("?status=Rejected");
                      }}
                    >
                      Rejected (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "?status=Rejected" ? "black" : "blue",
                          marginTop: "1px",
                        }}
                      >
                        {rejectdata?.meta?.total}
                      </span>
                      )
                    </span>

                    <span
                      style={{
                        display: "flex",
                        color:
                          status === "?status=Deactivated" ? "blue" : "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      onClick={() => {
                        setStatus("?status=Deactivated");
                      }}
                    >
                      Deactivated (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          color:
                            status == "?status=Deactivated" ? "black" : "blue",
                          marginTop: "1px",
                        }}
                      >
                        {deactivedata?.meta?.total}
                      </span>
                      )
                    </span>
                  </div>

                  <div
                    ref={tableRef}
                    style={{ maxWidth: "100%", overflowX: "auto" }}
                  >
                    <Table
                      className="align-items-center table-flush "
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">S.NO</th>
                          <th scope="col">profile Pic</th>
                          <th scope="col">Name</th>
                          <th scope="col">Email</th>
                          <th scope="col">Mobile No.</th>
                          <th scope="col">Joining Date</th>
                          <th scope="col">City</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td
                              colSpan={12}
                              className="text-center align-middle w-full"
                            >
                              Please wait...
                              <Loader />
                            </td>
                          </tr>
                        ) : filteredData?.length > 0 ? 
                        (
                          filteredData?.map((tutorItem, tutorIndex) => (
                            <tr key={`tutor${tutorIndex}`}>
                              <td style={{ padding: "0.3rem" }}>
                                {(currentPage - 1) * perPage + tutorIndex + 1}
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                               
                              
                                  <img
                                    onClick={() =>
                                      window.open(
                                        tutorItem.auth_user?.profilePic,
                                        "_blank",
                                        "width=500,height=500"
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      height: "50px",
                                      width: "50px",
                                      borderRadius: "50%",
                                      border: "1px solid gray",
                                      objectFit: "cover",
                                    }}
                                    src={tutorItem.auth_user?.profilePic || noimage}
                                    // alt="Tutor Profile"
                                  />
                                
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                <Link
                                  to={`tutorsprofile/${tutorItem?.user_id}/${tutorItem?.mobile}`}
                                >
                                  {tutorItem?.auth_user?.first_name}{" "}
                                  {tutorItem?.auth_user?.last_name}
                                </Link>
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                {tutorItem?.auth_user?.email}
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                {tutorItem?.mobile}
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                {moment(tutorItem?.date_joined).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )}
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                {tutorItem?.city}
                              </td>
                              <td style={{ padding: "0.3rem" }}>
                                <Badge
                                  className={
                                    tutorItem?.auth_user?.is_active == true
                                      ? "status-active"
                                      : "status-discontinued"
                                  }
                                >
                                  {tutorItem?.auth_user?.is_active == true
                                    ? "Active"
                                    : "Deactive"}
                                </Badge>
                              </td>
                              <td
                                style={{ display: "flex", padding: "0.3rem" }}
                              >
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`eyeTooltipr-${tutorIndex}`}
                                >
                                  View
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    justifyContent: "center",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "flex",
                                    marginTop: "16px",
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id={`eyeTooltipr-${tutorIndex}`}
                                  to={`tutorsprofile/${tutorItem?.user_id}/${tutorItem?.mobile}`}
                                >
                                  <i class="fa-solid fa-eye"></i>
                                </Link>
                                {tutorItem?.auth_user?.is_active == false && (
                                  <>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`userTooltip${tutorIndex}`}
                                    >
                                      Active
                                    </UncontrolledTooltip>
                                    <p
                                      style={{
                                        margin: "0 8px",
                                        fontSize: "15px",
                                        color: "green",
                                        marginTop: "15px",
                                        // backgroundColor: "#f5f5f5",
                                        display: "inline-block",
                                        // padding: "5px", // Optional: Add padding for better appearance
                                        borderRadius: "20%", // Optional: Make it a circle
                                      }}
                                      id={`userTooltip${tutorIndex}`}
                                      onClick={() =>
                                        handleAcc(tutorItem?.user_id)
                                      }
                                    >
                                      <i class="fa-solid fa-user-plus"></i>
                                    </p>
                                  </>
                                )}
                                {tutorItem?.auth_user?.is_active == true && (
                                  <>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`userTooltip1${tutorIndex}`}
                                    >
                                      Deactive
                                    </UncontrolledTooltip>
                                    <p
                                      style={{
                                        margin: "0 8px",
                                        fontSize: "15px",
                                        color: "red",
                                        marginTop: "15px",
                                        // backgroundColor: "#f5f5f5",
                                        display: "inline-block",
                                        // padding: "5px", // Optional: Add padding for better appearance
                                        borderRadius: "20%", // Optional: Make it a circle
                                      }}
                                      id={`userTooltip1${tutorIndex}`}
                                      onClick={() =>
                                        handleDel(tutorItem?.user_id)
                                      }
                                    >
                                      <i class="fa-solid fa-user-xmark"></i>
                                    </p>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="12"
                              style={{ textAlign: "center", padding: "1rem" }}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>

              <CardFooter className="py-4">
                <TablePagination
                  totalPages={totalpage}
                  currentPage={currentPage}
                  pageUrl="/admin/tutors?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </> 
  </>
  );
};

export default TutorPage;
